import { Navigate } from 'react-router'


export type ProtectedRouteProps = {
  defaultPath: string;
  outlet: JSX.Element;
  isLoggedIn?: boolean;
  isAdmin?: boolean;
};


/**
 * Component that redirects to default path if user is not logged in or admin.
 * Source: https://stackoverflow.com/questions/47747754/how-to-rewrite-the-protected-private-route-using-typescript-and-react-router-4
 * @param protectedRouteProps 
 * @returns Component according to user properties.
 */
export default function ProtectedRoute({ isAdmin, isLoggedIn, defaultPath, outlet }: ProtectedRouteProps) {
  // Note: If isAdmin or isLoggedIn are not specified, then it will navigate to given path.
  if (isAdmin === false || isLoggedIn === false) {
    return <Navigate to={{ pathname: defaultPath }} />;
  } else {
    return outlet;
  }
}
